module.exports = __webpack_public_path__ + "img/wx-logo.1e970b88.png";